import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { ProductContextFacade } from 'ish-core/facades/product-context.facade';

/**
 * The Product ID Component renders the product id with a label.
 */
@Component({
  selector: 'ish-product-id',
  templateUrl: './product-id.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule],
})
export class ProductIdComponent implements OnInit {
  private context = inject(ProductContextFacade);

  visible$: Observable<boolean>;
  sku$: Observable<string>;

  ngOnInit() {
    this.visible$ = this.context.select('displayProperties', 'sku');
    this.sku$ = this.context.select('product', 'sku');
  }
}
